<template>
  <navbar>
    <div v-if="!isTotemRoute">
      <button ref="SidebarToggler" class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <ul class="nav navbar-nav d-md-down-none">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarMinimize">&#9776;</a>
      </li>
    </ul>
    </div>
    <router-link :to="{ name: 'PaginaInicial' }" class="navbar-brand"><small :class="display"></small></router-link>
    <ul class="nav navbar-nav ml-auto" v-if="!isTotemRoute">
      <b-dropdown class="notificaAgenda" variant="link" right lazy no-caret>
        <template #button-content>
          <div class="d-flex align-items-center" style="height: 35px;">
            <div>
              <i style="font-size: 1.5rem" class="text-light nav-item fas fa-calendar fa-lg">
                <span
                  v-if="newSchedule.length !== 0"
                  style="top: 10px; font-size: 10px; background-color: #f50000;"
                  class="badge badge-default"
                >{{ newSchedule.length >= 10 ? '10+' : newSchedule.length }}</span>
              </i>
            </div>
          </div>
        </template>
        <b-dropdown-form>
          <Agenda @openCard="showLead"></Agenda>
        </b-dropdown-form>
      </b-dropdown>
      <b-dropdown class="notificaOportunidades" variant="link" ref="alert-dropdown" right lazy no-caret>
        <template #button-content>
          <div class="d-flex align-items-center" style="height: 35px;">
            <div>
              <i style="font-size: 1.5rem" class="text-light nav-item fas fa-bell fa-lg">
                <span
                  v-if="totalNewOportunities !== 0"
                  style="top: 10px; font-size: 10px; background-color: #f50000;"
                  class="badge badge-default"
                >{{ totalNewOportunities >= 10 ? '10+' : totalNewOportunities }}</span>
              </i>
            </div>
          </div>
        </template>
        <b-dropdown-form>
          <oportunidades @openCard="showLead"></oportunidades>
        </b-dropdown-form>
      </b-dropdown>
      <b-dropdown class="notificaAtendimento" variant="link" ref="alert-dropdown" right lazy no-caret>
        <template #button-content>
          <div class="d-flex align-items-center" style="height: 35px;">
            <div>
              <i style="font-size: 1.5rem" class="text-light nav-item fas fa-headset fa-lg">
                <span
                  v-if="totalNewAtendimento !== 0"
                  style="top: 10px; font-size: 10px; background-color: #f50000;"
                  class="badge badge-default"
                >{{ totalNewAtendimento >= 10 ? '10+' : totalNewAtendimento }}</span>
              </i>
            </div>
          </div>
        </template>
        <b-dropdown-form>
          <atendimento @openCard="showConversation"></atendimento>
        </b-dropdown-form>
      </b-dropdown>
      <li class="divider-vertical d-md-down-none mr-3"></li>
      <!-- Dropdown para alterar o status do usuário -->
      <b-dropdown variant="link" no-caret class="status-dropdown mr-3">
        <template #button-content>
          <i class="fa fa-circle" :class="getStatusClass(userStatus)" style="margin-right: 5px;"></i>
          <span class="d-md-down-none" style="color: #fff;">{{ statusLabels[userStatus] || userStatus }}</span>

        </template>
        <b-dropdown-item v-for="status in statuses" :key="status" @click="changeUserStatus(status)">
          <i class="fa fa-circle" :class="getStatusClass(status)" style="margin-right: 5px;"></i>
          {{ statusLabels[status] || status }}
        </b-dropdown-item>
      </b-dropdown>

      <!-- Dropdown do ícone de usuário -->
      <b-dropdown variant="link" no-caret class="je-test user-dropdown">
        <template slot="button-content">
          <b-avatar class="mr-2"></b-avatar>
          <span class="d-md-down-none" style="min-width: 190px; color: #fff;">{{ AccountName }}</span>
          <i class="fa fa-caret-down" style="color:#fff;"></i>
        </template>
        <b-dropdown-item :to="{ name: 'AlterarSenha' }"><i class="fa fa-key"></i> Alterar Senha</b-dropdown-item>
        <b-dropdown-item v-if="isAdministrador" :to="{ name: 'Environment' }"><i class="fa fa-cogs"></i> Configuração</b-dropdown-item>
        <b-dropdown-item v-if="isAdministrador" :to="{ name: 'RelatorioAcesso' }"><i class="fa fa-users"></i> Relatório de Acessos</b-dropdown-item>
        <b-dropdown-item v-if="isAdministradorModulo" :to="{ name: 'Modules' }"><i class="fa fa-plug"></i> Configuração dos Módulos</b-dropdown-item>
        <b-dropdown-item href="javascript:void(0)" @click="onSignOut"><i class="fa fa-lock"></i> Sair</b-dropdown-item>
      </b-dropdown>

      <li class="pr5 d-md-down-none">&nbsp;</li>
    </ul>
    <ModalCard ref="ModalCard" v-if="selectedCard" @hideModal="hideLead" :key="selectedCard" :cardId="selectedCard" />
  </navbar>
</template>
<script>
import AccountMixin from '@/store/module/account/mixin'
import { JWTService } from '@/shared/services/jwt'
import Tools from '@/components/tools/Tools.js'
import navbar from './Navbar'
import Agenda from '../../components/UI/notificacao/Agenda.vue'
import Oportunidades from '../../components/UI/notificacao/Oportunidades.vue'
import Atendimento from '../../components/UI/notificacao/Atendimento.vue'
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'
import NotificationsAtendimentoRepository from '@/shared/http/repositories/crm/notificationsatendimento.js'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'

import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import moment from 'moment'

import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'headerApp',
  mixins: [AccountMixin],
  data () {
    return {
      isAdministrador: false,
      display: '',
      imgAvatar: process.env.BaseURL + 'static/img/avatars/02.png',
      screenW: screen.width,
      totalNewOportunities: [],
      newSchedule: [],
      selectedCard: null,
      totalNewAtendimento: [],
      newAtendimento: [],
      stompClient: null,
      isConnected: false,
      isAdministradorModulo: false,
      userStatus: '',
      statuses: ['ONLINE', 'OFFLINE', 'AWAY'],
      statusLabels: {
        ONLINE: 'Online',
        OFFLINE: 'Offline',
        AWAY: 'Ausente'
      }

    }
  },
  components: {
    navbar,
    Agenda,
    Oportunidades,
    Atendimento,
    ModalCard
  },
  created () {
    Tools.AuthorizeNotification()
    if (JWTService.GetRoles().includes('ADMINISTRADOR')) {
      this.isAdministrador = true
    } if (JWTService.GetRoles().includes('IS_MASTER')) {
      this.isAdministradorModulo = true
    }
    this.getNotificationAndSchedule()
    this.connect()
    this.fetchUserStatus() // Busca o status do usuário apenas uma vez ao criar o componente
  },
  beforeDestroy () {
    this.disconnect()
  },
  computed: {
    AccountName: function () {
      var result = JWTService.GetTokenPayload().nome
      if (this.account && this.account.name) {
        result = this.account.name
      } else if (result !== '') {
        result = result.toUpperCase()
      }
      return result
    },
    isTotemRoute () {
      return this.$route.path === '/totem' || this.$route.path === '/tv'
    },
    statusClass () {
      return this.getStatusClass(this.userStatus)
    }
  },
  methods: {
    connect () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`)
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, frame => {
        this.isConnected = true
        this.subscribeToConversations()
      }, error => {
        this.isConnected = false
        console.error('Connection error: ' + error)
      })
    },
    disconnect () {
      if (this.stompClient !== null) {
        this.stompClient.disconnect()
      }
    },
    subscribeToConversations () {
      if (this.isConnected) {
        const topic = '/topic/notifications/notviewed'

        this.stompClient.subscribe(topic, result => {
          if (result.body === 'true') this.getNotificationAndSchedule()
        })
      }
    },
    onSignOut () {
      JWTService.DestroyToken()
      location.reload()
    },
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
      // this.display = 'none'
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getNotificationAndSchedule () {
      NotificationsCardRepository.searchNotificationsUserCustom('visualizado=false')
        .then(response => {
          this.totalNewOportunities = response.data.totalElements
        })
      NotificationsCardRepository.searchNotificationsUserCustom('visualizado=false&agendamento=true')
        .then(response => {
          this.newSchedule = response.data.content
        })
      NotificationsAtendimentoRepository.searchNotificationsUserCustom('visualizado=false')
        .then(response => {
          this.newAtendimento = response.data.content
        })
      NotificationsAtendimentoRepository.searchNotificationsUserCustom('visualizado=false&atendimento=true')
        .then(response => {
          this.totalNewAtendimento = response.data.totalElements
        })

      try {
        if (
          this.totalNewOportunities > 0 ||
          this.newSchedule.length > 0 ||
          this.newAtendimento.length > 0 ||
          this.totalNewAtendimento > 0
        ) {
          Tools.ShowNotification('NEXUM: Atenção', 'Você possui novas notificações!\nClique aqui para visualizá-las. (' + moment().format('DD/MM/YYYY HH:mm:ss') + ')')
        }
      } catch (error) {
        console.error('Error fetching notifications:', error)
      }
    },
    showLead (cardId) {
      this.selectedCard = cardId
    },
    showConversation (conversationId) {
      this.selectedConversation = conversationId
    },
    hideLead () {
      this.selectedCard = null
      this.getNotificationAndSchedule()
    },
    fetchUserStatus () {
      if (!this.userStatus) {
        AccountRepository.GetById(this.account.id)
          .then(response => {
            this.userStatus = response.data.status
          })
          .catch(error => {
            console.error('Erro ao buscar o status do usuário:', error)
          })
      }
    },
    changeUserStatus (status) {
      AccountRepository.PatchUserStatus({ status })
        .then(response => {
          this.userStatus = response.data.status
          this.fetchUserStatus()
          this.$bvToast.toast('Status do usuário atualizado com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            solid: true
          })
        })
        .catch(error => {
          console.error('Erro ao atualizar o status do usuário:', error)
          this.$bvToast.toast('Erro ao atualizar o status do usuário.', {
            title: 'Erro',
            variant: 'danger',
            solid: true
          })
        })
    },
    getStatusClass (status) {
      const statusClasses = {
        ONLINE: 'text-success',
        OFFLINE: 'text-secondary',
        AWAY: 'text-warning'
      }
      return statusClasses[status] || 'text-secondary'
    }
  }
}
</script>
<style>
.je-test ul {
  transform: translate3d(0px, 53px, 0px);
}

.notification {
  background-color: #dee2e5;
}

@media only screen and (max-width: 600px){

  .notificaOportunidades.dropdown.b-dropdown > .dropdown-menu{
    transform: translate3d(-30px, 53px, 0px) !important;
  }
  .notificaAgenda.dropdown.b-dropdown > .dropdown-menu{
    transform: translate3d(10.5px, 53px, 0px) !important;
  }
  .notificaAgenda > button{
    margin-right: -.75rem;
  }
}

@media (max-width: 768px) {
  .user-dropdown .dropdown-menu {
    right: -80px !important;
    left: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Header.vue